// extracted by mini-css-extract-plugin
export default {"root":"MobileFormInput_root__1YSdU","input":"MobileFormInput_input__RIspy","withError":"MobileFormInput_withError__+ujEX","errorText":"MobileFormInput_errorText__6wRr2"};